export type VersionableId = {
  readonly commitId: string;
  readonly resourceName: string;
};

export const convertVersionableIdToString = (versionableId: VersionableId): string => (
  `${versionableId.commitId}#${versionableId.resourceName}`
);
